import getRating from '../share/getRating'
import { AggregateRatingsProps } from '../types'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface pageDataProps {
  show_ratings: {
    value: boolean
  } | undefined
}

interface contextDataProps {
  aggregateRatings: AggregateRatingsProps
}

const getRatingsData = (pageData: pageDataProps, contextData: contextDataProps) => {
  const { t } = useTranslation('translation')
  const { featuredImageTitle, customerFeedback, reviewsTranslation } = useMemo(
    () => ({
      featuredImageTitle: t('do_you_like_it'),
      customerFeedback: t('customer_feedback'),
      reviewsTranslation: t('reviews'),
    }),
    [],
  )
  const showRatings = pageData.show_ratings?.value
  const aggregateRatings = contextData.aggregateRatings
  const rating = getRating(aggregateRatings)
  const { showRatingContent, ratingDescription } = useMemo(
    () => ({
      showRatingContent: showRatings && rating,
      ratingDescription:
        showRatings && rating ? `/ 5.0 (${rating.amount} ${reviewsTranslation})` : '',
    }),
    [showRatings, rating],
  )

  return {
    showRatings,
    aggregateRatings,
    showRatingContent,
    featuredImageTitle,
    ratingDescription,
    customerFeedback,
    rating
  }
}

export default getRatingsData
